import { type PropsWithChildren } from 'react';
import styled from 'styled-components';

export const PageSidePanelItem = ({
	children,
	title
}: PropsWithChildren<{
	title?: string | undefined;
}>) => {
	return (
		<S.SidePanelItemWrapper>
			{title && <S.SidePanelTitle>{title}</S.SidePanelTitle>}
			<S.SidePanelContent>{children}</S.SidePanelContent>
		</S.SidePanelItemWrapper>
	);
};

namespace S {
	export const SidePanelItemWrapper = styled.div`
		gap: ${({ theme }) => theme.spacings.small};
	`;
	export const SidePanelTitle = styled.h1`
		color: ${({ theme }) => theme.colors.text.main.enabled};
		${({ theme }) => theme.fonts.headings.title5};
	`;
	export const SidePanelContent = styled.div`
		border-radius: ${({ theme }) => theme.spacings.xxsmall};
		overflow: auto;
		display: flex;
		flex-direction: column;
	`;
}
